module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Click <strong>here</strong> to select your csv file"}}')
  delete Component.options._Ctor
}
